<div class="spinner-wrapper" role="status" aria-live="polite">
    <ryui-loader [theme]="'default'"></ryui-loader>
</div>